import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Can from 'components/Common/Can';
import { PERMISSIONS } from 'constants/permissions';
import { SHOP_PATHS } from 'routes/routesConstants';
import './ShopNewSaleFab.css';

const ShopNewSaleFab: React.FC = () => {
  const { shopId } = useParams<{ shopId: string }>();

  if (!shopId) return null;

  const newSalePath = SHOP_PATHS.MEDICINE_SELL_ENTRY.replace(':shopId', shopId);

  return (
    <Can permission={PERMISSIONS.CREATE_SALES}>
      <Link to={newSalePath} className="shop-new-sale-fab" title="Create new sale invoice">
        <i className="bx bx-plus-circle" />
        <span>New Sale</span>
      </Link>
    </Can>
  );
};

export default ShopNewSaleFab;
